import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {
  Button,
  Grid,
  TextField,
  FormControlLabel,
  RadioGroup,
  Radio,
  FormControl
} from '@material-ui/core';
import * as yup from 'yup';
import {Formik} from 'formik';
import {createAdditionalSpecialsApi, editAdditionalSpecialsApi} from 'api/subscription';


const SpecialsForm = ({special, setSpecial}) => {
  const dispatch = useDispatch();
  const {additionalSpecials} = useSelector((state) => state.subscription);
  const additionalSpecialsSortOrders = additionalSpecials.reduce((orders, el) => {
    if (el.order !== special?.order) {
      return [...orders, el.order];
    }

    return orders;
  }, []);

  return (
    <>
      <Formik
        initialValues={{
          _id: special?._id || '',
          specialValue: special?.value || '',
          order: special?.order || 0,
          price: special?.price || '',
          isOneTime: special?.isOneTime || false
        }}
        onSubmit={async (values) => {
          const special = {
            value: values.specialValue,
            order: values.order,
            price: values.price,
            isOneTime: values.isOneTime
          };

          if (values._id) {
            await editAdditionalSpecialsApi({dispatch, specialId: values._id, special});
          } else {
            await createAdditionalSpecialsApi({dispatch, special});
          }

          setSpecial(null);
        }}
        validationSchema={
          yup.object({
            specialValue: yup
              .number()
              .typeError('Sku value must be a number')
              .required('Field is required')
              .min(0, 'Value cannot go lower than 0'),
            order: yup
              .number()
              .min(0, 'Value cannot go lower than 0')
              .notOneOf(additionalSpecialsSortOrders, 'Sort order already specified')
              .typeError('Order value must be a number')
              .required('Field is required'),
            price: yup
              .number()
              .typeError('Price value must be a number')
              .required('Field is required')
              .min(0, 'Value cannot go lower than 0'),
          })
        }
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          setFieldValue
        }) => (
          <form autoComplete="off" className="p-8" onSubmit={handleSubmit}>
            <Grid container spacing={3} className="p-4">
              <Grid item xs={12} sm={12} md={12}>
                <FormControl>
                  <RadioGroup
                    name="isOneTime"
                    value={values.isOneTime ? '1' : '0'}
                    onChange={({target: {value}}) => setFieldValue('isOneTime', value === '1')}
                    row
                  >
                    <FormControlLabel
                      control={<Radio color="primary" />}
                      label="One Time Price"
                      value="1"
                    />

                    <FormControlLabel
                      control={<Radio color="primary" />}
                      label="Monthly Subscription Price"
                      value="0"
                    />
                  </RadioGroup>
                </FormControl>
                <TextField
                  required
                  className="w-full mt-10"
                  label="Price"
                  name="price"
                  variant="outlined"
                  value={values.price}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.price && Boolean(errors.price)}
                  helperText={touched.price && errors.price}
                />
                <TextField
                  required
                  className="w-full mt-5"
                  label="Value"
                  name="specialValue"
                  variant="outlined"
                  value={values.specialValue}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.specialValue && Boolean(errors.specialValue)}
                  helperText={touched.specialValue && errors.specialValue}
                />
                <TextField
                  required
                  className="w-full mt-5"
                  label="Order"
                  name="order"
                  variant="outlined"
                  value={values.order}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.order && Boolean(errors.order)}
                  helperText={touched.order && errors.order}
                />
                <div className="flex items-center justify-end mt-8">
                  <Button
                    variant="contained"
                    onClick={() => setSpecial(null)}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    className="mx-10"
                    type="submit"
                  >
                    Submit
                  </Button>
                </div>
              </Grid>
            </Grid>
          </form>
        )}
      </Formik>
    </>
  );
};

export default SpecialsForm;
